import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BreathingFlow from "../components/breathing-flow/BreathingFlow.jsx";
import TopbarInner from "../components/topbar/TopbarInner";

export default function BreathingPage({
  sounds = [],
  user = null,
  isPremium = false,
  premiumSoundIds = [],
  naturalSounds = [],
  favoriteNatureSoundIds = [],
  currentStreak = 0,
  preferredIntent = "",
  dailyTime = null,
  longestStreak = 0,
  onLockedDuration,
  onLockedSound,
  onLockedAuria,
  onBeforePlayerLaunch,
  onPrepareAuriaSession,
  onStart,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [flowStep, setFlowStep] = useState(0);

  const handleBack = useCallback(() => {
    if (flowStep > 0) {
      navigate(-1);
      return;
    }
    if (location.state?.from === "/") {
      navigate(-1);
      return;
    }
    navigate("/", { replace: true });
  }, [flowStep, location.state, navigate]);

  return (
    <div className="app-fill app-safe--no-top app-route--breathing-flow">
      <div className="header-floating app-header--compact app-header--breathing-flow">
        <TopbarInner
          titleColor="#36495B"
          isPremium={isPremium}
          longestStreak={longestStreak}
          showLogo
          onBack={handleBack}
        />
      </div>

      <div className="app-fill app-safe--no-top app-fill--breathing-flow">
        <div className="welcome-container welcome-container--respirations welcome-container--breathing-flow">
          <div className="welcome-card cq-hero welcome-card--breathing-flow">
            <BreathingFlow
              sounds={sounds}
              user={user}
              isPremium={isPremium}
              premiumSoundIds={premiumSoundIds}
              naturalSounds={naturalSounds}
              favoriteNatureSoundIds={favoriteNatureSoundIds}
              currentStreak={currentStreak}
              preferredIntent={preferredIntent}
              dailyTime={dailyTime}
              onStepChange={setFlowStep}
              useTopbarNavigation
              onLockedDuration={onLockedDuration}
              onLockedSound={onLockedSound}
              onLockedAuria={onLockedAuria}
              onBeforePlayerLaunch={onBeforePlayerLaunch}
              onPrepareAuriaSession={onPrepareAuriaSession}
              onStart={onStart}
            />
          </div>
        </div>
      </div>
    </div>
  );
}